import React, { FC } from 'react'
import { DuplicateIcon } from '@heroicons/react/solid'
import { DownloadIcon } from '@heroicons/react/outline'
import { SearchStorySets_searchStorySets_docs } from '../../../graphql/StorySet/__generated__/SearchStorySets'
import { StyledStorySetItem } from '.'
import { linkToSizedImage } from '../../IssueEntityImage/helpers'
import { Button } from '../../System'
import useSegment from '../../utils/useSegment'
import ROUTES from '../../utils/routes'

type Props = {
  storySet: SearchStorySets_searchStorySets_docs;
  onClick: () => void;
}

const StorySetItem: FC<Props> = ({ storySet, onClick }) => {
  const THUMBNAIL_SIZE = { height: 500 }
  const { track } = useSegment()

  const handleStoryDownload = (e) => {
    e.stopPropagation()
    track('Downloaded Story', {
      id: storySet._id,
      title: storySet.title,
      url: storySet.thumbnail,
      index: storySet.index,
      issue_id: storySet.issue,
      from: 'stories'
    })
  }

  return (
    <StyledStorySetItem to={ROUTES.stories.storyById(storySet._id)} onClick={() => onClick()}>
      <div className="story-img">
        <div className="story-count">
          <DuplicateIcon /> <span>{storySet.stories?.length || 0}</span>
        </div>
        <Button
          onClick={(e) => handleStoryDownload(e)}
          externalURL={linkToSizedImage(storySet.thumbnail || '', {})}
          className="photo-draft-btn"
          theme="ghost"
          isIcon
        >
          <DownloadIcon />
        </Button>
        <img
          src={linkToSizedImage(storySet.thumbnail || '', THUMBNAIL_SIZE)}
          alt={storySet.title || undefined}
        />
      </div>
      <span className="story-title">{storySet.title}</span>
    </StyledStorySetItem>
  )
}

export default StorySetItem
